export default "__VITE_ASSET__BnkwBbVo__"